import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Col, Row } from 'react-bootstrap';
import { DataTable, DataTableLoading, DataTableRecordsNotFound } from '../widgets/DataTable';
import { getQAppLogList } from '../../actions/hardware';
import QappLogsItem from './QappLogsItem';

const HardwareActivityInfo = (props) => {
    const { isRequesting, qappLogs, hardwareId, deviceId, actions } = props;

    useEffect(() => {
        if (deviceId && !qappLogs) actions.getQAppLogList(hardwareId, {
            device_uuid: [deviceId],
            sort_field: "log_date",
            sort_order: "desc",
            limit_count: 50
        })
    }, [deviceId]);

    return <Row className="m-0 qapp-logs">
        <Col className="p-0">
            <DataTable className='tbl-fixed'>
                <DataTable.Header className="tbl-header">
                    <DataTable.Row>
                        <DataTable.Cell style={{ width: "40px" }}>#</DataTable.Cell>
                        <DataTable.Cell style={{ width: "180px", textAlign: "center" }}>Component</DataTable.Cell>
                        <DataTable.Cell style={{ textAlign: "center" }}>Message</DataTable.Cell>
                        <DataTable.Cell style={{ width: "180px", textAlign: "center" }}>Log Date</DataTable.Cell>
                        <DataTable.Cell style={{ width: "50px" }}></DataTable.Cell>
                    </DataTable.Row>
                </DataTable.Header>
                <DataTable.Body>
                    {(!isRequesting && qappLogs && qappLogs.length > 0) &&
                        qappLogs.map((item, i) => <QappLogsItem key={i} item={item} index={i} />)}
                </DataTable.Body>
            </DataTable>
            {isRequesting && <DataTableLoading />}
            {(!isRequesting && qappLogs && qappLogs.length === 0) && <DataTableRecordsNotFound />}
        </Col>
    </Row>
}

const mapStateToProps = (state, { hardwareId }) => {
    const qappLogsInfo = state.hardware.qappLogsById[`${hardwareId}`]
        ? state.hardware.qappLogsById[`${hardwareId}`] : null;
    return {
        isRequesting: qappLogsInfo ? qappLogsInfo.isRequesting : false,
        qappLogs: qappLogsInfo ? qappLogsInfo.payload : null
    };
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ getQAppLogList }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(HardwareActivityInfo);